import cx from 'classnames'

const runnableTrackClasses = [
  '[&::-webkit-slider-runnable-track]:bg-gray-400',
  '[&::-webkit-slider-runnable-track]:h-2',
  '[&::-webkit-slider-runnable-track]:rounded-full',
  '[&::-webkit-slider-runnable-track]:shadow-inner'
].join(' ')

const thumbClasses = [
  '[&::-webkit-slider-thumb]:appearance-none',
  '[&::-webkit-slider-thumb]:w-6',
  '[&::-webkit-slider-thumb]:h-6',
  '[&::-webkit-slider-thumb]:bg-white',
  '[&::-webkit-slider-thumb]:rounded-full',
  '[&::-webkit-slider-thumb]:border',
  '[&::-webkit-slider-thumb]:border-gray-700',
  '[&::-webkit-slider-thumb]:shadow-tooltip',
  '[&::-webkit-slider-thumb]:-mt-1.5'
].join(' ')

export function Slider({
  min,
  max,
  value,
  onChange,
  showValue = false,
  step = 1,
  onMouseUp,
  name
}: {
  min: number
  max: number
  value: number
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  showValue?: boolean
  step?: number
  onMouseUp?: (e: React.MouseEvent<HTMLInputElement>) => void
  name?: string
}) {
  const labelPosition = ((value - min) / (max - min)) * 100

  return (
    <div className={cx('relative w-full', showValue && 'mb-4')}>
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        step={step}
        onMouseUp={onMouseUp}
        onChange={onChange}
        name={name}
        className={cx(
          'w-full appearance-none bg-transparent cursor-pointer ',
          runnableTrackClasses,
          thumbClasses
        )}
      />
      {showValue && (
        <div
          className="absolute left-0 transform -translate-x-1/2 translate-y-2 text-text-secondary text-xs"
          style={{
            left: `${labelPosition}%`,
            top: '100%'
          }}
        >
          {value}
        </div>
      )}
    </div>
  )
}
